import { useEffect } from "react"

interface CategoryOption {
  id: string
}

export function useCategorySync(
  categoryOptions: CategoryOption[],
  selectedCategory: string,
  setSelectedCategory: (category: string) => void,
  isReady: boolean,
): void {
  useEffect(() => {
    if (!isReady) return
    if (categoryOptions.length > 0 && !categoryOptions.some(({ id }) => id === selectedCategory)) {
      setSelectedCategory(categoryOptions[0].id)
    }
  }, [categoryOptions, selectedCategory, setSelectedCategory, isReady])
}
